import React from 'react';
import PropTypes from 'prop-types';
import HtmlContent from '../HtmlContent';

export default class FormInputCheckbox extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange = (event) => {
    const { fieldData, userInputHandler } = this.props;

    let value = '';
    if (event.currentTarget.checked) {
      value = event.currentTarget.value;
    }
    userInputHandler(fieldData.name, value);
  };

  render() {
    const { fieldData, fieldInput } = this.props;

    return (
      <label>
        <input
          type="checkbox"
          name={fieldData.name}
          onChange={this.onChange}
          value={fieldData.value}
          checked={fieldData.value === fieldInput}
        />
        <HtmlContent content={fieldData.desc} />
      </label>
    );
  }
}

FormInputCheckbox.propTypes = {
  fieldData: PropTypes.shape({
    field_type: PropTypes.string,
    req: PropTypes.string,
    desc_pos: PropTypes.string,
    name: PropTypes.string,
    desc: PropTypes.string,
    placeholder: PropTypes.string,
    email_conf: PropTypes.string,
    value: PropTypes.string,
    repeat: PropTypes.array,
  }).isRequired,
  fieldInput: PropTypes.string.isRequired,
  userInputHandler: PropTypes.func.isRequired,
};
